(function(){
    'use strict';

    Components.GoogleRedirect = {
        controller: 'GoogleRedirectController',
        name: 'hbGoogleRedirect',
        templateUrl: 'angular/app/modules/core/features/google_integration/google_redirect_page_template.html',
    };
})();